const de = {
  nav: {
    studio: "Studio",
    servizi: "Leistungen",
    portfolio: "Portfolio",
    team: "Team",
    journal: "Journal",
    studioTagline: "Digitalstudio",
    contatti: "Kontakt",
    parliamone: "Sprechen wir",
  },
  common: {
    iniziamoProgetto: "Projekt starten",
    scriviStudio: "An das Studio schreiben",
    vediServizi: "Alle Leistungen ansehen",
    conosciStudio: "Studio kennenlernen",
    scopriDiPiu: "Mehr erfahren",
  },
  footer: {
    overline: "Studio · 2026",
    headline1: "Wir gestalten",
    headlineEditorial: "digitale Erlebnisse",
    headline2: "nach Mass.",
    navHeading: "Navigation",
    writeHeading: "Schreiben Sie uns",
    tagline:
      "3D-Modellierung · Prototyping · Digitale Umgebungen · Kreative Betreuung.",
    rights: "Alle Rechte vorbehalten",
    madeWith: "Made with quiet obsession",
  },
  home: {
    hero: {
      overline: "Digitalstudio · Gegründet von Riccardo & Sasha",
      title1: "Wir geben",
      titleEditorial: "Form",
      title2: "eurer",
      title3: "Vorstellung.",
      paragraph:
        "Mysterious Stew ist ein Zwei-Personen-Studio, das 3D-Modellierung, Prototyping und digitale Umgebungen in einer einzigen Kreativwerkstatt vereint — mit einem Netzwerk externer Mitarbeitender für jede Anforderung.",
      cta1: "Projekt starten",
      cta2: "Was wir tun",
    },
    marquee: [
      "3D-Modellierung",
      "Rendering",
      "Prototyping",
      "STL-Optimierung",
      "Digitale Umgebungen",
      "Creative Direction",
      "Print-ready",
      "Motion",
    ],
    services: {
      overline: "Leistungen · Vier Disziplinen",
      title1: "Ein Studio,",
      titleEditorial: "vier Materien",
      title2: "zum Komponieren.",
      paragraph:
        "Jedes Projekt wird als Unikat behandelt. Wir wählen die richtigen Kompetenzen — intern oder aus unserem Netzwerk — für das präziseste Ergebnis.",
      items: [
        {
          title: "3D-Modellierung",
          desc: "Hard-Surface- und organisches Sculpting. Assets für Rendering, Cinema, Games oder Druck.",
        },
        {
          title: "Prototyping & 3D-Druck",
          desc: "Von der Datei zum haptischen Objekt. Prototypen, Produktionsmaster, limitierte Serien.",
        },
        {
          title: "Digitale Umgebungen",
          desc: "Virtuelle Sets, immersive Räume, fotorealistische Szenen für Storytelling und Produkt.",
        },
        {
          title: "Digitale Betreuung",
          desc: "Fortlaufende kreative Regie: Beratung, Workflow, Content-Produktion und Koordination.",
        },
      ],
    },
    studio: {
      overline: "Das Studio · Zwei Gründer",
      titleRiccardo: "Riccardo",
      titleAmp: "&",
      titleSasha: "Sasha.",
      titleLine2: "Ein Core Team,",
      titleLine3: "ein erweitertes Netzwerk.",
      paragraph:
        "Wir sind zu zweit, aber nicht allein. Für jedes Projekt stellen wir das richtige Team zusammen — mit Illustratoren, Animatoren, Bildhauern und Entwicklern, mit denen wir seit Jahren arbeiten.",
      role: "Mitgründer",
    },
    finalCta: {
      overline: "Nächster Schritt",
      title1: "Habt ihr eine Idee?",
      titleEditorial: "Lasst sie uns zusammen kochen.",
      button: "An das Studio schreiben",
    },
  },
  services: {
    header: {
      overline: "Leistungen",
      title1: "Vier Disziplinen,",
      titleEditorial: "eine gemeinsame Sprache",
      titleEnd: ".",
      paragraph:
        "Wir liefern keine vorgefertigten Pakete. Jedes Projekt wird — gemeinsam — vom ersten Sketch bis zur finalen Übergabe durchlaufen, mit den richtigen Kompetenzen zur richtigen Zeit.",
    },
    items: [
      {
        tag: "3D",
        title: "3D-Modellierung",
        desc: "Hard-Surface- und organisches Sculpting, Low-Poly- und High-Poly-Modeling. Assets für fotorealistische Renderings, Cinema, Games oder 3D-Druck.",
        deliverables: [
          "STL / OBJ / FBX Modelle",
          "Retopology & UV",
          "Iteratives Concept-to-model",
          "Produktionsmaster",
        ],
      },
      {
        tag: "PRINT",
        title: "Prototyping & 3D-Druck",
        desc: "Von der Datei zum haptischen Objekt. Supportvorbereitung, Optimierung für Resin/FDM, funktionale Prototypen und limitierte Serien.",
        deliverables: [
          "Print-ready Dateien",
          "Supports & Orientierung",
          "Funktionale Prototypen",
          "Limitierte Editionen",
        ],
      },
      {
        tag: "ENV",
        title: "Digitale Umgebungen",
        desc: "Virtuelle Sets, immersive Räume, fotorealistische oder stilisierte Szenen für Storytelling, Produktpräsentation, interaktive Erlebnisse.",
        deliverables: [
          "Fotorealistische Szenen",
          "Virtuelle Sets",
          "Real-time-Previews",
          "Animierte Sequenzen",
        ],
      },
      {
        tag: "STUDIO",
        title: "Digitale Betreuung",
        desc: "Fortlaufende kreative Regie: Beratung, Workflow-Definition, Content-Produktion und Koordination mit externen Partnern.",
        deliverables: [
          "Creative Direction",
          "Content-Produktion",
          "Workflow-Design",
          "Team on-demand",
        ],
      },
    ],
    cta: {
      overline: "Ein hybrides Briefing?",
      title1: "Die besten Projekte",
      title2: "entstehen an der",
      titleEditorial: "Grenze",
      titleEnd: ".",
      button: "Erzählen Sie uns von Ihrem Projekt",
    },
  },
  team: {
    intro: {
      overline: "Das Studio",
      title1: "Zwei Hände",
      titleEditorial: "viele Stimmen",
      titleEnd: ".",
      paragraph:
        "Das Core Team besteht aus zwei Personen. Um uns herum rotiert ein stabiles Netzwerk externer Mitarbeitender — Illustratoren, Animatoren, Bildhauer, Entwickler — mit dem wir für jedes Projekt das richtige Team zusammenstellen, ohne die Kohärenz zu verlieren.",
    },
    founders: [
      {
        name: "Riccardo",
        role: "Mitgründer · Digitales Sculpting & Creative Direction",
        badge: "Mitgründer 01",
        bio: "Modelliert Figuren, Silhouetten und Posen. Führt die visuelle Ästhetik des Studios und gibt der taktilen, materiellen Seite unserer Arbeit eine Stimme.",
        focus: ["Sculpting", "Character design", "Art direction"],
      },
      {
        name: "Sasha",
        role: "Mitgründer · Hard-Surface & technischer Workflow",
        badge: "Mitgründer 02",
        bio: "Betreut die technische Seite: Hard-Surface, Retopology, Printability und die Struktur unserer End-to-End-Workflows.",
        focus: ["Hard-surface", "Printability", "Tech pipeline"],
      },
    ],
    crew: {
      overline: "Das erweiterte Netzwerk",
      title1: "Ein Team, das sich",
      titleEditorial: "zusammensetzt",
      title2: "um das Projekt.",
      paragraph:
        "Wir sind keine Agentur mit festen Abteilungen. Wir aktivieren die richtigen Profile projektbezogen — wir zwei bleiben die Konstante für Richtung, Qualität und Kontinuität.",
      items: [
        { role: "Illustratoren", count: "02", desc: "Konzept und Visual Development." },
        { role: "Animatoren", count: "02", desc: "Motion und animierte Sequenzen." },
        { role: "Bildhauer", count: "03", desc: "Finish und Spezialteile." },
        { role: "Entwickler", count: "02", desc: "Backend und Web-Integrationen." },
      ],
    },
    manifesto: {
      overline: "Unsere Art",
      quote:
        "\u201EWir bevorzugen wenige Projekte mit obsessiver Sorgfalt, statt viele in Eile.\u201C",
      button: "Mit uns arbeiten",
    },
  },
  portfolio: {
    header: {
      overline: "Portfolio · Auswahl",
      title1: "Projekte,",
      titleEditorial: "keine Produkte",
      titleEnd: ".",
      paragraph:
        "Eine Auswahl der jüngsten Kollaborationen des Studios — von Modellierung über digitale Umgebungen bis zu 3D-druckfertigen Prototypen.",
    },
    projects: [
      {
        id: "obsidian-vault",
        title: "Obsidian Vault",
        tag: "Digitale Umgebung",
        desc: "Immersive Umgebung für ein Luxus-Produktlaunch: Modellierung, Lighting und Post-Produktion.",
      },
      {
        id: "forma-01",
        title: "Forma 01",
        tag: "3D-Modellierung",
        desc: "Serie abstrakter digitaler Skulpturen für eine limitierte Kollektion.",
      },
      {
        id: "corpo-solido",
        title: "Corpo Solido",
        tag: "Prototyping",
        desc: "Rapid Prototyping eines mechanischen Bauteils. Iteration von der Datei zum fertigen Objekt.",
      },
      {
        id: "vitrea",
        title: "Vitrea",
        tag: "Digitale Umgebung",
        desc: "Virtuelles Set für eine Editorial-Kampagne einer Accessoire-Marke.",
      },
      {
        id: "atelier-site",
        title: "Atelier — Editorial-Site",
        tag: "Website",
        desc: "Massgeschneiderte Website für ein Studio für zeitgenössische Kunst. Design, Entwicklung und CMS.",
      },
      {
        id: "collettivo",
        title: "Collettivo",
        tag: "Kreative Betreuung",
        desc: "Fortlaufende Beratung für ein Künstlerkollektiv: Workflow und Content-Produktion.",
      },
    ],
    cta: {
      overline: "Ein ähnliches Projekt?",
      title1: "Jedes Projekt hat",
      title2: "seine",
      titleEditorial: "richtige Frage",
      titleEnd: ".",
      button: "Beginnen wir das Gespräch",
    },
  },
  journal: {
    header: {
      overline: "Journal · Notizen aus dem Studio",
      title1: "Notizen,",
      titleEditorial: "keine Tutorials",
      titleEnd: ".",
      paragraph:
        "Gedanken, Behind-the-scenes und Reflexionen zum Handwerk. Wir aktualisieren das Journal, wenn wir etwas Schreibenswertes haben — nicht um einen Kalender zu füllen.",
    },
    tags: [
      "3D",
      "Modellierung",
      "Print",
      "Studio Notes",
      "Workflow",
      "Creative Direction",
      "Umgebungen",
      "Kollaborationen",
    ],
    readTimeLabel: "Lesen",
    readTimeUnit: "Min",
    backLabel: "Zurück zum Journal",
    moreLabel: "Weitere Notizen",
    entries: [
      {
        slug: "superficie-e-luce",
        date: "12. 02. 2026",
        tag: "Studio-Notiz",
        title: "Wie wir Luxus-3D-Modellierung denken",
        excerpt:
          "Eine interne Notiz, die öffentlich wurde: warum unsere Oberflächen-Obsession weniger mit Glanz und viel mehr mit Licht zu tun hat.",
        readTime: "6",
        intro:
          "Diese Notiz entstand aus einem internen Gespräch im Studio, vor einem Render, der uns nicht überzeugte. Das Modell war technisch makellos — und wirkte trotzdem… billig. Daraus wurde eine Überlegung, was ein digitales Objekt wirklich »luxuriös« macht.",
        sections: [
          {
            h: "Oberfläche ist nicht Politur",
            p: "Wenn von High-End-Modellierung die Rede ist, will der Instinkt hinzufügen: mehr Polygone, mehr Reflexionen, mehr Details. Wir haben gelernt, das Gegenteil zu tun. Eine Luxus-Oberfläche ist eine kontrollierte Oberfläche — kontinuierliche Krümmungen, saubere Übergänge, keine zufälligen Fehler. Detail existiert nur dort, wo es gebraucht wird, und jede Fase hat einen durchdachten Radius.",
          },
          {
            h: "Das Licht erzählt die Form",
            p: "Ein Modell beurteilt man, indem man ein Licht über seine Oberfläche bewegt. Fließen die Reflexionen ohne Brüche, ist die Form gelöst; zerspringen sie, rettet sie kein Material mehr. Deshalb verbringen wir mehr Zeit mit Krümmungen als mit Texturen: Die Wahrnehmung von Qualität entsteht dort, lange vor dem finalen Render.",
          },
          {
            h: "Was das für unsere Kunden bedeutet",
            p: "Es bedeutet, dass unsere Angebote einen unsichtbaren Posten enthalten: die Zeit für das, was man auf den ersten Blick nicht sieht, aber immer spürt. Es ist der Unterschied zwischen einem digitalen Objekt, das »funktioniert«, und einem, das echt, wertvoll und begehrenswert wirkt. Es ist der Grund, warum unsere Kunden wiederkommen.",
          },
        ],
      },
      {
        slug: "anatomia-prototipo",
        date: "24. 01. 2026",
        tag: "Workflow",
        title: "Vom Sketch zum Print — die Anatomie eines Prototyps",
        excerpt:
          "Wir gehen ein aktuelles Projekt durch, um zu zeigen, wie wir Modellierung, Retopology und 3D-Druck vereinen, wenn jeder Millimeter zählt.",
        readTime: "9",
        intro:
          "Ein mechanisches Bauteil, enge Toleranzen und ein Kunde mit einer echten Deadline. Wir gehen die Etappen eines aktuellen Projekts durch, um zu zeigen, wie wir arbeiten, wenn eine Datei ein physisches Objekt werden muss.",
        sections: [
          {
            h: "Der erste Sketch ist schon Engineering",
            p: "Jeder Prototyp beginnt auf Papier, aber mit klaren Vorgaben ab dem ersten Strich: reale Maße, Belastungspunkte, Druckrichtung. Zeichnen, ohne an die Produktion zu denken, heißt später neu zeichnen. In unserem Workflow entstehen Form und Machbarkeit gemeinsam.",
          },
          {
            h: "Retopology: wo Millimeter gewonnen werden",
            p: "Der Übergang vom skulptierten Modell zur Produktions-Mesh ist die leiseste und kritischste Phase. Garantierte Mindestwandstärken, geschlossene Geometrien, geprüfte Oberflächen. Sasha kontrolliert jede kritische Zone mit Querschnitten: Wenn ein Teil in ein anderes passen muss, ist die Fehlertoleranz null.",
          },
          {
            h: "Der Druck ist eine Prüfung, kein Ziel",
            p: "Das erste gedruckte Teil ist nie das finale. Es dient dazu, zu messen, zu montieren, zu verstehen, wo die Realität von der Datei abweicht. Dieses Projekt brauchte drei Iterationen: Die dritte rastete mit einem sauberen Klick ein, ohne Spiel. Dieses Geräusch — ein präziser Klick — ist das eigentliche Deliverable.",
          },
        ],
      },
      {
        slug: "manifesto-pacchetti",
        date: "08. 01. 2026",
        tag: "Journal",
        title: "Ein kleines Manifest gegen fertige Pakete",
        excerpt:
          "Jedes Projekt ist ein anderes Problem. Deshalb bieten wir keine Standardpreislisten an und wie diese Wahl die Arbeit mit uns verändert.",
        readTime: "4",
        intro:
          "Man fragt uns oft: »Was kostet ein 3D-Modell? Und eine digitale Umgebung?«. Die ehrliche Antwort: Es kommt darauf an. Dieses kleine Manifest erklärt, warum wir keine Preisliste haben — und warum das ein Vorteil für alle ist, die mit uns arbeiten.",
        sections: [
          {
            h: "Jedes Projekt ist eine andere Frage",
            p: "Ein fertiges Paket setzt voraus, dass sich alle Probleme ähneln. Unsere Erfahrung sagt das Gegenteil: Dieselbe Anfrage — »ein Modell für den Druck« — kann drei Tage oder drei Wochen dauern, je nach Nutzung, Material und Finish. Preise machen, bevor man versteht, heißt schlecht kalkulieren.",
          },
          {
            h: "Das Angebot als erster Akt des Projekts",
            p: "Für uns ist ein Angebot keine Zahl: Es ist der erste Entwurf des Projekts. Es enthält die Phasen, die geplanten Iterationen, was enthalten ist und was wir zu verschieben empfehlen. Wer unser Angebot liest, weiß schon vor der Unterschrift, wie wir zusammenarbeiten werden.",
          },
          {
            h: "Weniger Projekte, besser gemacht",
            p: "Die Paket-Logik abzulehnen zwingt uns zu wählen: Wir nehmen nur Projekte an, denen wir echte Aufmerksamkeit widmen können. Kommerziell ist das gegen den Strom — aber genau deshalb trägt jede Arbeit, die das Studio verlässt, dieselbe Sorgfalt, vom ersten bis zum letzten Pixel.",
          },
        ],
      },
      {
        slug: "rete-estesa",
        date: "22. 12. 2025",
        tag: "Kollaborationen",
        title: "Das erweiterte Netzwerk: wer hinter jedem Projekt steht",
        excerpt:
          "Illustratoren, Animatoren, Bildhauer. Die Menschen im Umfeld des Core Teams und wie sie für jeden Auftrag ausgewählt werden.",
        readTime: "5",
        intro:
          "Auf der Website schreiben wir »ein Core Team aus zwei Personen, ein erweitertes Netzwerk von Kollaborateuren«. Aber was heißt das konkret? Wer arbeitet wirklich an Ihren Projekten, und wie wählen wir aus, mit wem wir arbeiten?",
        sections: [
          {
            h: "Zwei Personen als Fixpunkt",
            p: "Riccardo und Sasha begleiten jedes Projekt von Anfang bis Ende: Creative Direction, Kundenbeziehung, Qualitätskontrolle. Nichts verlässt das Studio, ohne durch unsere Hände gegangen zu sein. Das garantiert Kohärenz — derselbe Standard, dieselbe Stimme, bei jeder Lieferung.",
          },
          {
            h: "Wie wir unsere Kollaborateure auswählen",
            p: "Das erweiterte Netzwerk ist keine Liste von Freelancern auf Abruf: Es sind Profis, mit denen wir seit Jahren arbeiten — Illustratoren, Animatoren, Bildhauer, Entwickler. Jeder wurde nach echten Projekten ausgewählt, nicht nach Gesprächen. Wer in unserem Netzwerk steht, hat bereits bewiesen, dass er unseren Standard hält.",
          },
          {
            h: "Der Vorteil für den Kunden",
            p: "Dieses Modell vereint das Beste aus zwei Welten: die Sorgfalt und direkte Verantwortung eines kleinen Studios mit der Produktionskapazität eines größeren Teams. Der Kunde spricht immer mit uns beiden, aber hinter jedem Projekt formiert sich genau das Team, das dieser Auftrag verlangt.",
          },
        ],
      },
    ],
    cta: {
      overline: "Bleiben wir in Kontakt",
      title1: "Wenige Notizen,",
      titleEditorial: "wenn es zählt",
      titleEnd: ".",
      button: "Schreiben Sie uns für Kollaborationen",
    },
  },
  contact: {
    header: {
      overline: "Kontakt",
      title1: "Lassen wir uns",
      title2: "darüber",
      titleEditorial: "sprechen",
      titleEnd: ".",
      paragraph:
        "Ein Projekt im Kopf, eine Idee zum Erkunden, eine Frage? Schreibt uns in Ruhe. Riccardo und Sasha antworten persönlich innerhalb weniger Tage.",
    },
    form: {
      nameLabel: "Name",
      namePlaceholder: "Wie heisst du?",
      emailLabel: "E-Mail",
      emailPlaceholder: "du@email.com",
      subjectLabel: "Worüber sprechen wir?",
      messageLabel: "Nachricht",
      messagePlaceholder: "Erzählt uns vom Projekt, der Idee, dem Deadline…",
      hint: "Wir antworten persönlich, meist innerhalb von 3 Werktagen.",
      submit: "Nachricht senden",
      submitting: "Wird gesendet…",
      validationError: "Bitte Name, E-Mail und Nachricht ausfüllen.",
      sendError: "Fehler beim Senden. Bitte gleich noch einmal versuchen.",
      successToast: "Nachricht gesendet — wir melden uns bald.",
    },
    services: [
      "3D-Modellierung",
      "Prototyping & 3D-Druck",
      "Digitale Umgebungen",
      "Digitale Betreuung",
      "Anderes",
    ],
    wizard: {
      stepWord: "Schritt",
      ofWord: "von",
      step1Title: "Woran arbeiten wir?",
      step2Title: "Welches Budget haben Sie im Kopf?",
      step2Hint: "Eine Schätzung hilft nur, das Angebot auszurichten — unverbindlich.",
      budgetOptions: ["Unter 500 €", "500 – 1.500 €", "1.500 – 5.000 €", "Über 5.000 €", "Gemeinsam festlegen"],
      step3Title: "Wann brauchen Sie es?",
      timelineOptions: ["Dringend (innerhalb 2 Wochen)", "Innerhalb 1 Monat", "1 – 3 Monate", "Flexibel"],
      step4Title: "Erzählen Sie uns vom Projekt",
      step5Title: "Ihre Kontaktdaten",
      summaryTitle: "Zusammenfassung der Anfrage",
      next: "Weiter",
      back: "Zurück",
      selectHint: "Wählen Sie eine Option, um fortzufahren",
    },
    thanks: {
      overline: "Erhalten",
      title1: "Danke —",
      titleEditorial: "wir sind gleich wieder da",
      titleEnd: ".",
      paragraph:
        "Eure Nachricht ist im Studio angekommen. Wir antworten persönlich innerhalb weniger Werktage.",
      again: "Eine weitere Nachricht schreiben",
    },
    info: {
      emailTitle: "Direkte E-Mail",
      emailNote:
        "Für Kollaborationen, Druckanfragen oder Kostenvoranschläge. Wir antworten persönlich.",
      whereTitle: "Wo wir sind",
      whereValue: "Italien",
      whereNote: "Remote Studio · wir arbeiten mit Kunden in Europa und darüber hinaus.",
      timeTitle: "Antwortzeiten",
      timeValue: "3 Werktage",
      timeNote: "Wir antworten auf jede Nachricht, eine nach der anderen.",
    },
  },
  seo: {
    home: {
      title: "Mysterious Stew — Digitalstudio · 3D, Druck und digitale Umgebungen",
      description:
        "Das Digitalstudio von Riccardo und Sasha: 3D-Modellierung, Prototyping und 3D-Druck, digitale Umgebungen und kreative Begleitung nach Maß.",
    },
    servizi: {
      title: "Leistungen — 3D-Modellierung, 3D-Druck und digitale Umgebungen · Mysterious Stew",
      description:
        "Vier Disziplinen, eine Sprache: 3D-Modellierung, Prototyping und 3D-Druck, digitale Umgebungen und kontinuierlicher digitaler Support.",
    },
    team: {
      title: "Das Studio — Riccardo & Sasha · Mysterious Stew",
      description:
        "Zwei Gründer, ein erweitertes Netzwerk: Illustratoren, Animatoren, Bildhauer und Entwickler, die sich um jedes Projekt formieren.",
    },
    journal: {
      title: "Journal — Notizen aus dem Studio · Mysterious Stew",
      description:
        "Notizen, Blicke hinter die Kulissen und Reflexionen über das Handwerk: 3D-Modellierung, Druck-Workflows, Creative Direction.",
    },
    contatti: {
      title: "Kontakt — Starten wir ein Projekt · Mysterious Stew",
      description:
        "Erzählen Sie uns von Ihrem Projekt: 3D-Modellierung, Prototyping, digitale Umgebungen oder kreative Begleitung. Persönliche Antwort innerhalb von 3 Tagen.",
    },
  },
  mmf: {
    views: "Aufrufe",
    likes: "Likes",
    followers: "Follower",
    models: "Veröffentlichte Modelle",
    visit: "Alles auf MyMiniFactory ansehen",
    collectionsLabel: "Unsere Fraktionen",
    viewerLabel: "3D-Vorschau",
    viewerTitle: "Zum",
    viewerTitleEditorial: "Anfassen.",
    viewerHint: "Ziehen zum Drehen",
    viewerLoading: "Modell wird geladen…",
    featuredLabel: "Ausgewählte Modelle",
  },
  language: {
    label: "Sprache",
  },
};

export default de;
